/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: frontgen
 * Version: 7.3.0-ALPHA-5
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import(/* webpackIgnore: true */ `/static/js/autoloader-handler.js?t=${Date.now()}`).then(({defineConfigurations}) => {
  defineConfigurations({
    condition: () => !!(document.querySelector('.toolbox .accordion, .ckeditor-accordion:not(:has(.accordion_toggler))')),
    scripts: ['/static/js/widget/transform-accordion.js']
  }, {
    condition: () => !!(document.querySelector('.toolbox .tabs, .ckeditor-tabs:not(:has(.tabs_toggler))')),
    scripts: ['/static/js/widget/transform-tabs.js']
  }, {
    condition: () => !!(document.querySelector('.toolbox .cke-paragraphmanager')),
    scripts: ['/static/js/widget/transform-paragraph.js']
  });
});
